// extracted by mini-css-extract-plugin
export default {"main":"Form_main__OQnNR"};